export default "__VITE_ASSET__vdaIJ26D__"